<template>
    <div class="container">
        <b-row class="signup justify-content-center">
            <b-col lg="5" md="8" sm="12">
                <div class="signup-box">
                    <img src="../assets/logo.png" height="39" width="179"/>

                    <b-form>
                        <b-form-group label="First Name" label-for="firstName">
                            <b-form-input id="firstName" v-model="signup.firstName" required></b-form-input>
                        </b-form-group>
                        <b-form-group label="Last Name" label-for="lastName">
                            <b-form-input id="lastName" v-model="signup.lastName" required></b-form-input>
                        </b-form-group>
                        <b-form-group label="Email Address" label-for="email">
                            <b-form-input id="email" type="email" v-model="signup.email" required></b-form-input>
                        </b-form-group>
                        <b-form-group label="Username" label-for="username">
                            <b-form-input id="username" v-model="signup.username" required></b-form-input>
                        </b-form-group>
                        <b-form-group label="Password" label-for="password">
                            <b-form-input id="password" type="password" v-model="signup.password" required></b-form-input>
                        </b-form-group>
                    </b-form>

                    <b-button variant="primary" @click="submit()">Signup</b-button>

                    <div v-if="error" class="error">{{error}}</div>

                    <!--<div class="container">-->
                    <!--<b-row class="login justify-content-center">-->
                    <!--<b-col lg="6" md="8" sm="12">-->
                    <!--<img src="../assets/logo.png" height="39" width="179"/>-->

                    <!--<div>-->
                    <!--<p>Ahh! Good! You are ready to get started? That's awesome!</p>-->
                    <!--<p>Unfortunately, we aren't quite as ready, which is less awesome. :(</p>-->
                    <!--<p>Please try back in a few days.</p>-->
                    <!--</div>-->
                    <!--</b-col>-->
                    <!--</b-row>-->

                    <!--</div>-->
                </div>

                <div class="login-box">
                    <h4>Do you already have an account?</h4>
                    <b-button variant="success" :to="{ name: 'Login'}">Login Now</b-button>
                </div>
            </b-col>

        </b-row>
    </div>

</template>

<script>
    import auth from '../services/auth';
    import router from '../router';

    export default {
        name: "login",
        data() {
            return {
                signup: {
                    firstName: '',
                    lastName: '',
                    email: '',
                    username: '',
                    password: ''
                },
                error: ''
            }
        },
        methods: {
            submit() {
                auth.signup(this.signup).then(() => {
                    router.push({name: 'Builder'});
                }, err => {
                    this.error = err;
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    img {
        margin: 0 0 40px -5px;
    }
    .signup {
        margin-top: 100px;

        .signup-box {
            font-family: "Roboto", sans-serif;

            padding: 30px;
            border: 2px solid transparent;
            border-radius: 5px;

            .error {
                padding: 10px 20px;
                border: 2px solid #ff0203;
                color: white;
                border-radius: 5px;
                margin-top: 30px;
            }
        }

        .login-box {
            font-family: "Roboto", sans-serif;

            margin-top: 30px;
            padding: 0 30px 30px;
            border: 2px solid rgb(7, 121, 4);
            border-radius: 5px;

            h4 {
                margin: 20px 0;
                font-size: 20px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/signup.vue